export default "__VITE_ASSET__IpRj3y1l__"